import { Progress } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  count: number;
  totalCount: number;
};

const ViewProgress: FC<Props> = ({ count, totalCount }) => (
  <div className="mx-auto w-full max-w-sm">
    <p className="text-center text-moon-12">
      <Translate
        id="general.load_more_games_info_text"
        values={{ count, totalCount }}
      />
    </p>
    <Progress value={Math.ceil((count / totalCount) * 100)} size="5xs" />
  </div>
);

export default ViewProgress;
